import { gql } from "graphql-request";
import * as z from "zod";
import { Image, ImageFragment } from "../image";
import { Sys, SysFragment } from "../sys";
import { UnifiedButton, UnifiedButtonFragment } from "../unifiedButton";

export const EsportCarouselLiveEntrySchema = z.object({
  __typename: z.literal("EsportLiveEventEntry"),
  sys: Sys,
  title: z.string().nullable(),
  entrySubtitle: z.string().nullable(),
  livestreamEndTime: z.string().nullable(),
  livestreamStartTime: z.string().nullable(),
  carouselImage: Image.nullable(),
  carouselImageEn: Image.nullable(),
  eventPromotionLogo: Image.nullable(),
  eventPromotionLogoEn: Image.nullable(),
  eventPromotionName: z.string().nullable(),
  watchLiveButton: UnifiedButton.nullish(),
  subscribeButton: UnifiedButton.nullish(),
  readMoreButton: UnifiedButton.nullish(),
});

export type EsportCarouselLiveEntry = z.infer<
  typeof EsportCarouselLiveEntrySchema
>;

export const EsportCarouselLiveEntryFragment = gql`
  fragment EsportCarouselLiveEntryFragment on EsportLiveEventEntry {
    __typename
    sys {
      ...SysFragment
    }
    title
    entrySubtitle
    livestreamEndTime
    livestreamStartTime
    carouselImage {
      ...ImageFragment
    }
    carouselImageEn: carouselImage(locale: "en") {
      ...ImageFragment
    }
    eventPromotionLogo {
      ...ImageFragment
    }
    eventPromotionLogoEn: eventPromotionLogo(locale: "en") {
      ...ImageFragment
    }
    eventPromotionName
    watchLiveButton {
      ... on UnifiedButton {
        ...UnifiedButtonFragment
      }
    }

    subscribeButton {
      ... on UnifiedButton {
        ...UnifiedButtonFragment
      }
    }

    readMoreButton {
      ... on UnifiedButton {
        ...UnifiedButtonFragment
      }
    }
  }

  ${ImageFragment}
  ${SysFragment}
  ${UnifiedButtonFragment}
`;
